// src/constants/columns/ticketColumns.js

import { IconButton } from "@mui/material";
import { MdDelete } from "react-icons/md";

export const ticketColumns = (deleteContact) => [
  { field: "name", headerName: "Name", flex: 1, minWidth: 150 },
  { field: "email", headerName: "Email", flex: 1, minWidth: 200 },
  { field: "phone", headerName: "Phone", flex: 1, minWidth: 150 },
  { field: "subject", headerName: "Subject", flex: 1, minWidth: 200 },
  { field: "message", headerName: "Message", flex: 1.5, minWidth: 300 },
  {
    field: "action",
    headerName: "Action",
    flex: 0.5,
    minWidth: 100,
    sortable: false,
    renderCell: (params) => (
      <IconButton color="error" onClick={() => deleteContact(params.row)}>
        <MdDelete size={24} />
      </IconButton>
    ),
  },
];
